import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, forwardRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { LoginVm } from 'app/shared/generated/Models/LoginVm';
import { SecurityService } from 'app/core/security/security.service';
import { SystemMessageService, SystemMessage } from 'app/core/system-message/system-message-service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';

@Component({
    selector: 'pcg-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnDestroy, OnInit, AfterViewInit {
	@ViewChild('myForm', { static: true }) myForm: ElementRef;

	loginForm = LoginVm.Form;
	subscriptions: Subscription = new Subscription();

	constructor(private route: ActivatedRoute, private ms: SystemMessageService, private sec: SecurityService,
		private router: Router, title: Title) {
		title.setTitle('Login');
	}

	ngOnInit() {
		const user = this.sec.getUser();
		if (user) { this.loginRedirect(); }
	}

	ngAfterViewInit() { }

	onSubmit() {
		if (this.loginForm.valid) {
			this.sec.setLocalStorage('lastAccess', new Date());
			this.subscriptions.add(this.ms.getHttpObservable(this, 'api/Account/Login', this.loginForm)
				.subscribe(msg => { this.doLogin(msg); })
			);
		} else { validateForm(this.loginForm); }
	}

	doLogin(msg: SystemMessage) {
		const val = msg.value;
		if (!val) { return; }
		this.loginForm.reset();
		this.sec.setSecurity(val.token, val.user, val.security);
		this.loginRedirect();
	}

	loginRedirect() {
		let redirectUrl = this.route.snapshot.queryParamMap.get('redirectUrl') || sessionStorage.getItem('redirectUrl');
		if (redirectUrl) {
			const baseUrl = document.getElementsByTagName('base')[0].href;
			redirectUrl = redirectUrl.replace(/^\//, '');
			if (redirectUrl.startsWith('uploads/') || redirectUrl.startsWith('quartz')) {
				window.location.href = baseUrl + redirectUrl;
			} else {
				this.router.navigateByUrl(redirectUrl);
				sessionStorage.removeItem('redirectUrl');
			}
		} else {
			this.router.navigate(['/dashboard']);
		}
	}

	ngOnDestroy() { this.subscriptions.unsubscribe(); }
}
